import { cloneDeep } from 'lodash';
import { updateOrRemove } from '../utils';
import { defineTransform } from '../transform';
import { transformOpRange } from '../transformCursor';

const RemoveAnnotationTransform = (editor, op) => {
  const {
    annotation: { key },
  } = op;
  if (!editor.metadata) return;
  if (!editor.metadata.annotations) return;
  if (!Object.hasOwn(editor.metadata.annotations, key)) return;

  editor.metadata.annotations[key].range?.unref?.();

  delete editor.metadata.annotations[key];
};

export default RemoveAnnotationTransform;

function transformAnnotation(annotationOp, op) {
  return transformOpRange(annotationOp, 'annotation', op);
}

defineTransform('remove_annotation', 'insert_text', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'remove_text', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'split_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'merge_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'move_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'insert_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'remove_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'set_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'add_mark', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'remove_mark', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'set_mark', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'set_selection', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('remove_annotation', 'add_annotation', (op1, op2, side) => {
  // remove vs add always defers to the remove
  return op1;
});

defineTransform(
  'remove_annotation',
  'remove_annotation',
  (op1, op2, side) => op1
);

defineTransform('remove_annotation', 'set_annotation', (op1, op2, side) => {
  if (op1.annotation.key !== op2.properties.key) return op1;

  // Update the delete's properties with the new properties after the set
  let tOp = cloneDeep(op1);
  tOp.annotation = {
    ...op1.annotation,
    ...op2.properties,
    ...op2.newProperties,
  };

  tOp = updateOrRemove(tOp, ['data', 'annotation'], op2.data.newProperties);

  return tOp;
});

defineTransform('remove_annotation', 'add_metadata', (op1, op2, side) => op1);
defineTransform(
  'remove_annotation',
  'remove_metadata',
  (op1, op2, side) => op1
);
defineTransform('remove_annotation', 'set_metadata', (op1, op2, side) => op1);
